export const ALLOWED_AD_GROUPS = ['MEDSOL.App.PADI.ViewAllSensitiveDocuments'];

export const ALLOWED_DELETE_GROUPS = ['MEDSOL.App.PADI.AllowSoftDelete'];

export const LIMITED_ALLOWED_AD_GROUP = ['MEDSOL.App.PADI.ViewLimitedSensitiveDocuments'];
export const CMADPermissionOverridableDocs = ["Driver's License Front Side", 'Social Security Card'];
